import React, { FC } from 'react'

//@ts-ignore
// import LKFetcherButton from 'shared/LKFetcherButton'
import { actions as DCActions } from '../../../DetailsContainer'

import translate from '../../translator'

import { UndoVisaLoanButtonProps } from '../../types.LoanDetails'
import LKFetcherButton from 'src/features/shared/LKFetcherButtonNew'
import { loanVisaUndo } from 'src/store/loan'

const UndoVisaLoanButton: FC<UndoVisaLoanButtonProps> = ({ type, ID, hash, disabled }) => (
  // <LKFetcherButton
  //   fetcherName={`Loan-${ID}-UndoVisa`}
  //   APICall={Loan.loanOper}
  //   disabled={disabled}
  //   params={{
  //     LoanID: ID,
  //     HashSum_LoanID_: hash,
  //     page: 'visaundo',
  //   }}
  //   successCallbackActions={[DCActions.fetchPage({ type, ID, hash, page: 'base' })]}
  //   style={{ display: 'flex', marginBottom: 5, marginLeft: 'auto' }}
  //   alias="bullet_green_delete"
  // >
  //   {translate('cmd_delete_collateral_visa')}
  // </LKFetcherButton>

  //UPDATED API REQUEST loan_oper_api page: visaundo
  <LKFetcherButton
    buttonAction={loanVisaUndo}
    params={{
      LoanID: ID,
      HashSum_LoanID_: hash,
    }}
    actionName={`Loan-${ID}-UndoVisa`}
    disabled={disabled}
    successCallbackActions={[DCActions.fetchPage({ type, ID, hash, page: 'base' })]}
    style={{ display: 'flex', marginBottom: 5, marginLeft: 'auto' }}
    alias="bullet_green_delete"
  >
    {translate('cmd_delete_collateral_visa')}
  </LKFetcherButton>
)

export default UndoVisaLoanButton
